var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumbersCustomers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2943_6201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9832 19.8439L13.9848 21.7784L14.4538 24.4938L11.9998 23.2126L9.54589 24.4938L10.0148 21.7784L8.01647 19.8439L10.777 19.4456L11.9998 16.985L13.2227 19.4456L15.9832 19.8439ZM23.9967 19.8502L21.2362 19.4518L20.0134 16.9913L18.7905 19.4518L16.03 19.8502L18.0284 21.7846L17.5594 24.5L20.0134 23.2189L22.4674 24.5L21.9984 21.7846L23.9967 19.8502ZM5.20916 19.4248L3.98627 16.9625L2.76343 19.4248L0.00292969 19.8234L2.0013 21.7592L1.53234 24.4765L3.98632 23.1944L6.44029 24.4765L5.97133 21.7592L7.9697 19.8234L5.20916 19.4248ZM5.37411 15.8459L3.57092 15.3337C4.08431 13.5265 5.19224 11.8986 6.69068 10.7498C7.3013 10.2817 7.95925 9.90106 8.65207 9.61112C7.51973 8.66477 6.79804 7.24262 6.79804 5.65491C6.79804 2.81249 9.11053 0.5 11.953 0.5C14.7954 0.5 17.1079 2.81249 17.1079 5.65491C17.1079 7.21394 16.4121 8.61341 15.3149 9.55947C16.0461 9.85199 16.7398 10.2448 17.3816 10.7337C18.8754 11.8718 19.9855 13.4868 20.5074 15.2812L18.7074 15.8046C17.8521 12.8638 15.1131 10.8099 12.0467 10.8099C8.96029 10.8099 6.21643 12.8807 5.37411 15.8459ZM8.67255 5.65496C8.67255 7.46377 10.1441 8.93536 11.953 8.93536C13.7618 8.93536 15.2333 7.46377 15.2333 5.65496C15.2333 3.84615 13.7618 2.37456 11.953 2.37456C10.1441 2.37456 8.67255 3.84615 8.67255 5.65496Z",
    fill: "#4D2481"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2943_6201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumbersCustomers);
export default __webpack_public_path__ + "static/media/numbers-customers.ee38211aaf65228c76e72d61b0c3d095.svg";
export { ForwardRef as ReactComponent };